import { z } from 'zod';
import {
  BaseElementSchema,
  ListStyleSchema,
  ParagraphStyleSchema,
  TypographyStyleSchema,
} from '@/components/canvas/document/schema/elementBase';

export { ListStyleSchema, ParagraphStyleSchema, TypographyStyleSchema };

const InlineTextStyleSchema = z.object({
  fontFamily: z.string().optional(),
  fontSize: z.number().optional(),
  fontWeight: z.union([z.string(), z.number()]).optional(),
  fontStyle: z.enum(['normal', 'italic']).optional(),
  color: z.string().optional(),
  letterSpacing: z.number().optional(),
  lineHeight: z.union([z.number(), z.string()]).optional(),
  bold: z.boolean().optional(),
  italic: z.boolean().optional(),
  underline: z.boolean().optional(),
  strike: z.boolean().optional(),
  superscript: z.boolean().optional(),
  subscript: z.boolean().optional(),
  link: z.object({
    href: z.string(),
    target: z.enum(['_blank', '_self']).optional(),
  }).optional(),
  backgroundColor: z.string().optional(),
}).strict();

const TextRunSchema = z.object({
  id: z.string(),
  text: z.string(),
  style: InlineTextStyleSchema.optional(),
}).strict();

const TextBlockSchema = z.object({
  id: z.string(),
  type: z.enum(['h1', 'h2', 'h3', 'paragraph', 'ordered-list-item', 'unordered-list-item']),
  runs: z.array(TextRunSchema).default([]),
}).strict();

export const TextDocumentSchema = z.object({
  version: z.literal(1).default(1),
  blocks: z.array(TextBlockSchema).default([]),
}).strict();

export const TextContentDataSchema = z.object({
  content: z.string().default(''),
  contentVersion: z.literal(1).default(1),
  document: TextDocumentSchema,
});

export const TextElementSchema = BaseElementSchema.extend({
  type: z.literal('text'),
  data: TextContentDataSchema,
});

export const TextStyleOverrideSchema = z.object({
  typography: TypographyStyleSchema.partial().optional(),
  paragraph: ParagraphStyleSchema.partial().optional(),
});
